<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 250px'>
        <p>所属供应商：</p>
        <el-input v-model='typeIpt' size='mini' style='width:150px' placeholder='请输入供应商' />
      </div>
      <div class='navContainer' style='width: 250px'>
        <p>中(英)文船名：</p>
        <el-input v-model='nameIpt' size='mini' style='width:150px' placeholder='请输入中(英)文船名' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>登录账号：</p>
        <el-input v-model='numbIpt' size='mini' style='width:150px' placeholder='请输入登录账号' />
      </div>
      <!--      <div class="navContainer">-->
      <!--        <p>船长：</p>-->
      <!--        <el-input v-model="captainIpt" size="mini" style="width:150px" placeholder="请选择船长名称"/>-->
      <!--      </div>-->
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='name' label='中(英)文船名' width='150px' align='center' />
          <el-table-column prop='supplierName' label='所属供应商' width='150px' align='center' />
          <el-table-column prop='account' label='登录账号' align='center' />
          <el-table-column prop='phone' label='联系电话' align='center' />
          <el-table-column prop='callNumber' label='呼号' align='center' />
          <!-- <el-table-column prop="imoNumber" label="IMO编号" align="center"/>
          <el-table-column prop="mmsi" label="MMSI" align="center"/> -->
          <!--          <el-table-column prop="shipName" label="船长" align="center"/>-->
          <!--          <el-table-column prop="shipPhone" label="船长手机号" align="center"/>-->
          <el-table-column prop='state' label='状态' width='60px' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.isEnable) }}</div>
          </el-table-column>
          <el-table-column prop='shipState' label='出航状态' width='70px' align='center'>
            <div slot-scope='scope'>{{ shipState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='350' align='center'>
            <template slot-scope='scope'>

              <el-button v-if='scope.row.isEnable' size='mini' type='danger'
                         @click='disableClick(scope.row.id)'>禁用
              </el-button>
              <el-button v-else size='mini' type='primary' @click='enableClick(scope.row.id)'>启用
              </el-button>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='detailClick(scope.row.id)'>详情
              </el-button>
              <el-button size='mini' type='primary' @click='changeClick(scope.row)'
                         class='yellow-bg'>修改
              </el-button>
              <el-button size='mini' type='primary' @click='resetClick(scope.row.id)'
                         class='resetBtn'>删除
              </el-button>
              <el-button size='mini' type='primary' @click='cabinClick(scope.row)' class='resetBtn'>
                船舱管理
              </el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='650px' center
               @close='dialogClose' :close-on-click-modal='false' top='10vh'>
      <div class='depart'>
        <el-form :model='shipData' label-width='110px' :rules='rules' v-loading='formLoading'
                 ref='ruleForm' size='medium'>
          <!-- <div style="display:flex;align-items:flex-end">
            <div class="line"/>
            <span>船舶信息</span>
          </div> -->
          <div-border label='基础信息'>
            <el-row>
              <el-col>
                <el-form-item label='所属供应商：' prop='type' style='margin-top: 15px'>
                  <el-select v-model='shipData.type' size='mini' filterable style='width:100%'
                             placeholder='请选择所属供应商' value-key='id'>
                    <el-option v-for='item in typeOption2' :key='item.id' :label='item.name'
                               :value='item' />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='登录账号：' prop='account'>
                  <el-input
                    :disabled="dialogTitle==='修改船舶'"
                    :style="'width:100%'"
                    v-model='shipData.account'
                    placeholder='请输入船舶登录账号'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='登录密码：' prop='password' v-if='!(dialogTitle==="修改船舶")'>
                  <el-input
                    :disabled="dialogTitle==='修改船舶'"
                    :style="'width:100%'"
                    v-model='shipData.password'
                    type='password'
                    placeholder='请输入船舶登录密码'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='中(英)文名称：' prop='name'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.name'
                    placeholder='请输入船舶中(英)文名称'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label='关键词：' prop='keyword'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.keyword'
                    placeholder='请输入船舶关键词'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='联系电话：' prop='sTell'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.sTell'
                    placeholder='请输入联系电话'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='呼号：' prop='numb'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.numb'
                    placeholder='请输入船舶呼号'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='IMO编号：' prop='IMO'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.IMO'
                    placeholder='请输入船舶IMO编号'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='MMSI：' prop='MMSI'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.MMSI'
                    placeholder='请输入船舶MMSI'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='总吨：' prop='size'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.size'
                    placeholder='请输入船舶总吨'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='载重吨：' prop='deadWeight'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.deadWeight'
                    placeholder='请输入船舶载重吨'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='最大船速：' prop='maxSpeed'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.maxSpeed'
                    placeholder='请输入船舶最大船速'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='经济船速：' prop='speed'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.speed'
                    placeholder='请输入船舶经济船速'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='长：' prop='long'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.long'
                    placeholder='请输入船舶长度'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='宽：' prop='width'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.width'
                    placeholder='请输入船舶宽度'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='高：' prop='height'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.height'
                    placeholder='请输入船舶高度'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='吃水：' prop='draft'>
                  <el-input
                    :style="'width:100%'"
                    v-model='shipData.draft'
                    placeholder='请输入船舶吃水'
                    autocomplete='off'
                    size='small'
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label='上传船舶' :is-need='true'>
            <el-row>
              <el-col>
                <el-form-item label='船舶照片：' style='margin-top: 15px'>
                  <div class='imgUp'>
                    <div class='imgLength'><span>{{ shipData.img.length }}/5</span></div>
                    <el-upload
                      ref='upload'
                      list-type='picture-card'
                      :action='uploadUrl'
                      :data='uploadData'
                      accept='image/png, image/jpeg, image/jpeg, image/bmp, image/gif'
                      :before-upload='beforeAvatarUpload'
                      :on-change='uploadChange'
                      :on-remove='handleRemove'
                      :on-progress='progress'
                      :on-success='success'
                      :file-list='shipData.img'
                      :limit=5
                    >
                      <!--                    <i class="el-icon-plus"/>-->
                      <div class='img-box'>
                        <i class='el-icon-plus' />
                        <span class='tips'>点击上传船舶照片</span>
                      </div>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <!-- <div-border label="船长信息">
            <el-row>
              <el-col :span="12">
                <el-form-item label="船长：" prop="captain" style="margin-bottom: 20px;margin-top: 15px;">
                  <el-input
                    :style="'width:100%'"
                    v-model="shipData.captain"
                    placeholder="请输入船长姓名"
                    autocomplete="off"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="船长电话：" prop="tell" style="margin-top: 15px;">
                  <el-input
                    :style="'width:100%'"
                    v-model="shipData.tell"
                    placeholder="请输入船长电话"
                    autocomplete="off"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div-border> -->
          <div class='btnContainer'>
            <el-button class='searchBtn' size='medium' :loading='imgIsUpload' @click='addClick'>确定
            </el-button>
            <el-button class='resetBtn' size='medium' @click='dialogClose'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title='详情船舶' :visible.sync='detailDialogVisible' width='650px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p :style='getStyle(detailData.isEnable)'>{{ getState(detailData.isEnable) }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>所属供应商：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>登录账号：</span>
              <span>{{ detailData.account }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>中(英)文名称：</span>
              <span>{{ detailData.name }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>关键词：</span>
              <span>{{ detailData.keyWord }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>呼号：</span>
                <span>{{ detailData.callNumber }}</span>
              </div>
              <div>
                <span class='span1'>联系电话：</span>
                <span>{{ detailData.phone }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>IMO编号：</span>
                <span>{{ detailData.imoNumber }}</span>
              </div>
              <div>
                <span class='span1'>MMSI：</span>
                <span>{{ detailData.mmsi }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>总吨：</span>
                <span>{{ detailData.grossTon }}</span>
              </div>
              <div>
                <span class='span1'>载重吨：</span>
                <span>{{ detailData.loadTon }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>最大船速：</span>
                <span>{{ detailData.maxSpeed }}</span>
              </div>
              <div>
                <span class='span1'>经济船速：</span>
                <span>{{ detailData.economySpeed }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>长x宽x高：</span>
                <span>{{ detailData.longSize }}x{{ detailData.widthSize }}x{{ detailData.heightSize
                  }}</span>
              </div>
              <div>
                <span class='span1'>吃水：</span>
                <span>{{ detailData.draft }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>船舶照片：</span>
              <div class='imgContainer'>
                <el-image
                  v-for='(item,index) in detailData.img'
                  :key='index'
                  style='width: 100px; height: 100px;margin-right:10px; '
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit='cover'
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">船长姓名：</span>
                <span>{{detailData.shipName}}</span>
              </div>
              <div>
                <span class="span1">船长手机号：</span>
                <span>{{detailData.shipPhone}}</span>
              </div>
            </div>
          </div>
        </div> -->
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='operationData' border>
              <el-table-column label='操作时间' align='center' width='160px'>
                <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title='船舱管理' :visible.sync='cabinVisible' width='650px' center>
      <div class='cabin'>
        <el-row>
          <el-col :span='24'>
            <div>中(英)文船名:<span>{{ cabinFrom.name }}</span></div>
          </el-col>
          <!-- <el-col :span="12">
            <div>呼号:<span>{{cabinFrom.callNumber}}</span></div>
          </el-col> -->
        </el-row>
        <div style='margin: 10px 0'>
          <p style='width:60px;display:inline-block'>船舱名：</p>
          <el-input v-model='shipTerm.cabinName' size='mini' style='width:120px;margin-right:20px'
                    placeholder='请输入船舱名' />
          <p style='width:45px;display:inline-block'>状态：</p>
          <el-select v-model='shipTerm.status' filterable size='mini'
                     style='width:120px;margin-right:20px' placeholder='请选择状态' value-key='id'>
            <el-option label='启用中' :value='1' />
            <el-option label='禁用中' :value='0' />
          </el-select>
          <el-button class='searchBtn' size='mini' @click='searchShip'>查询</el-button>
          <el-button class='resetBtn' size='mini' @click='resetShip'>重置</el-button>
          <el-button type='primary' size='mini' @click='cabinAdd'>添加</el-button>
        </div>
        <el-table
          v-loading='cabinLoad'
          :data='cabinTable'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px',}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px',}"
        >
          <el-table-column
            type='index'
            :index='tableIndexMethod'
            label='序号'
            width='50'
            align='center'
          ></el-table-column>
          <el-table-column prop='cabinName' label='船舱名' align='center' />
          <el-table-column prop='capacity' label='可停车数量' width='90' align='center' />
          <!-- <el-table-column prop="freeNumber" label="空闲数量" align="center"/> -->
          <el-table-column prop='status' label='状态' :formatter='getStatus' align='center' />
          <el-table-column label='操作' align='center' width='210px'>
            <template slot-scope='scope'>
              <el-button size='mini' type='primary' class='yellow-bg'
                         @click='cabinChangeClick(scope.row)'>修改
              </el-button>
              <el-button size='mini' :type="scope.row.status !==1 ? 'primary':'danger'"
                         @click='cabinEnableClick(scope.row.id)'>
                {{ scope.row.status !== 1 ? '启用' : '禁用' }}
              </el-button>
              <el-button size='mini' type='primary' @click='cabinResetClick(scope.row.id)'
                         class='resetBtn'>删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style='margin-top:10px'
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          :current-page.sync='cabinFrom.page'
          :page-size='cabinFrom.rows'
          :page-sizes='[10, 20, 30, 40]'
          background
          layout='total, sizes, prev, pager, next, jumper'
          :total='cabinTotal'
        >
        </el-pagination>

        <el-dialog :title='`${cabinDialogName}船舱`' :visible.sync='cabinAddVisible' append-to-body
                   center width='650px' @close='cabinDialogClose'>
          <div style='padding: 20px'>
            <el-form :model='cabinData' label-width='110px' :rules='cabinRules' ref='cabinRuleForm'
                     size='medium'>
              <el-form-item label='船舱名:' prop='cabinName'>
                <el-input size='mini' v-model='cabinData.cabinName' style='width: 100%'></el-input>
              </el-form-item>
              <el-form-item label='可停车数量:' prop='boatNumber'>
                <el-input size='mini' v-model='cabinData.boatNumber' style='width: 100%'></el-input>
              </el-form-item>
              <!-- <el-form-item label="空闲数量:" prop="freeNumber">
                <el-input size="mini" v-model="cabinData.freeNumber" style="width: 300px"></el-input>
              </el-form-item> -->
              <el-form-item label-width='0px'
                            style='display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: center;'>
                <el-button class='searchBtn' size='mini' @click='cabinAddClick'>
                  {{ cabinDialogName }}
                </el-button>
                <el-button class='resetBtn' size='mini' @click='cabinDialogClose'>关闭</el-button>
              </el-form-item>
            </el-form>
          </div>

        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDateTime, getSessionStore, removeSpace } from '@/config/mUtils';
  import {
    shipPageList,
    shipAdd,
    shipUpdate,
    shipIsEnable,
    shipDelete,
    shipDetail,
    shipCabinPageList,
    shipCabinAdd,
    shipCabinUpdate,
    shipCabinDelete,
    shipCabinIsEnable,
  } from '@/service/basicfile';
  import {
    highwayLineSelectWaterSupplier,
  } from '@/service/financial';
  import divBorder from '@/components/divBorder';
  import { baseUrl, baseImgUrl } from '@/config/env';

  export default {
    components: {
      divBorder,
    },

    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入船舶联系电话'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确的联系电话'));
        } else {
          callback();
        }
      };
      const validateTell2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入船长电话'));
        } else if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/).test(value)) {
          callback(new Error('请输入正确的联系电话'));
        } else {
          callback();
        }
      };
      const validateAcount = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error('请输入船舶登录账号'));
        } else if (value.length > 18 || value.length < 3) {
          callback(new Error('请输入6-18位以内的船舶登录账号'));
        } else {
          callback();
        }
      };
      const validatePass = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error('请输入船舶登录密码'));
        } else if (value.length > 18 || value.length < 6) {
          callback(new Error('请输入6-18位以内的船舶登录密码'));
        } else {
          callback();
        }
      };
      return {
        nameIpt: '',
        captainIpt: '',
        numbIpt: '',
        typeIpt: '',
        typeOption: [
          {
            id: '',
            name: '全部',
          },
        ],
        typeOption2: [],
        tableLoad: false,
        TableDatas: [],
        page: 1,
        size: 10,
        total: 0,
        dialogTitle: '',
        dialogVisible: false,
        token: getSessionStore('token'),
        shipData: {
          account: '',
          password: '',
          name: '',
          keyword: '',
          type: '',
          numb: '',
          sTell: '',
          age: '',
          IMO: '',
          MMSI: '',
          size: '',
          deadWeight: '',
          maxSpeed: '',
          speed: '',
          long: '',
          width: '',
          height: '',
          draft: '',
          img: [],
          captain: '',
          tell: '',
        },
        cabinVisible: false,
        cabinLoad: false,
        cabinTable: [
          {
            name: '船舱名',
          },
        ],
        cabinFrom: {
          rows: 10,
          page: 1,
        },
        cabinTotal: 0,
        cabinData: {
          shipId: '',
          cabinName: '',
          boatNumber: '',
          freeNumber: '',
        },
        tempShipId: '',  // 船舱管理暂存id
        cabinDialogName: '添加',
        cabinAddVisible: false,
        formLoading: false,

        rules: {
          account: [
            {
              required: true,
              validator: validateAcount,
              trigger: 'blur',
            },
          ],
          password: [
            {
              required: true,
              validator: validatePass,
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入船舶中(英)文名称',
              trigger: 'blur',
            },
          ],
          keyword: [
            {
              required: true,
              message: '请输入船舶关键词',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择船舶种类',
              trigger: 'change',
            },
          ],
          numb: [
            {
              required: true,
              message: '请输入船舶呼号',
              trigger: 'blur',
            },
          ],
          sTell: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          IMO: [
            {
              required: true,
              message: '请输入船舶IMO编号',
              trigger: 'blur',
            },
          ],
          MMSI: [
            {
              required: true,
              message: '请输入船舶MMSI',
              trigger: 'blur',
            },
          ],
          size: [
            {
              required: true,
              message: '请输入船舶总吨',
              trigger: 'blur',
            },
          ],
          deadWeight: [
            {
              required: true,
              message: '请输入船舶载重吨',
              trigger: 'blur',
            },
          ],
          maxSpeed: [
            {
              required: true,
              message: '请输入船舶最大船速',
              trigger: 'blur',
            },
          ],
          speed: [
            {
              required: true,
              message: '请输入船舶经济船速',
              trigger: 'blur',
            },
          ],
          long: [
            {
              required: true,
              message: '请输入船舶长度',
              trigger: 'blur',
            },
          ],
          width: [
            {
              required: true,
              message: '请输入船舶宽度',
              trigger: 'blur',
            },
          ],
          height: [
            {
              required: true,
              message: '请输入船舶高度',
              trigger: 'blur',
            },
          ],
          draft: [
            {
              required: true,
              message: '请输入船舶吃水',
              trigger: 'blur',
            },
          ],
          img: [
            {
              required: true,
              message: '请至少选择上传一张船舶照片',
              trigger: 'change',
            },
          ],
          captain: [
            {
              required: true,
              message: '请输入船长姓名',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              validator: validateTell2,
              trigger: 'blur',
            },
          ],
        },
        cabinRules: {
          cabinName: {
            required: true,
            message: '请输入船舱名',
            trigger: 'blur',
          },
          boatNumber: {
            required: true,
            message: '请输入可停车数量',
            trigger: 'blur',
          },
          // freeNumber:{ required: true, message: '请输入空闲数量', trigger: 'blur' },
        },
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        uploadData: {
          fileType: '1',
        },
        imgIsUpload: false,
        shipTerm: {   // 船舶管理查询条件
          cabinName: '',
          status: '',
        },
      };
    },
    computed: {
      getState() {
        return function(state) {
          switch (state) {
            case 1:
              return '启用中';
            case 0:
              return '禁用中';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 1:
              return 'color: #3388ff';
            case 0:
              return 'color:#F56C6C;';
          }
        };
      },
      shipState() {
        return function(state) {
          switch (state) {
            case 1:
              return '待出航';
            case 0:
              return '空闲中';
            case 2:
              return '航海中';
          }
        };
      },
    },
    mounted() {
      this.init();
      this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
    },
    methods: {
      async init() {
        await this._shipPageList();
        const res = await highwayLineSelectWaterSupplier();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.typeOption2 = res.data;
          res.data.forEach(item => this.typeOption.push(item));
        }
      },
      async _shipPageList() {
        this.tableLoad = true;
        const obj = {
          supplierName: this.typeIpt,
          name: this.nameIpt,
          account: this.numbIpt,
          shipName: this.captainIpt,
          rows: this.size,
          page: this.page,
        };
        const res = await shipPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      resetBtn() {
        this.nameIpt = '';
        this.captainIpt = '';
        this.numbIpt = '';
        this.typeIpt = '';
      },
      searchBtn() {
        this.page = 1;
        this._shipPageList();
      },
      addBtn() {
        this.dialogVisible = true;
        this.dialogTitle = '添加船舶';
        this.shipData = {
          account: '',
          password: '',
          name: '',
          keyword: '',
          type: '',
          numb: '',
          sTell: '',
          age: '',
          IMO: '',
          MMSI: '',
          size: '',
          deadWeight: '',
          maxSpeed: '',
          speed: '',
          long: '',
          width: '',
          height: '',
          draft: '',
          img: [],
          captain: '',
          tell: '',
        };
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._shipPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._shipPageList();
      },
      handleSizeChange(rows) {
        this.cabinFrom.rows = rows;
      },
      handleCurrentChange(page) {
        this.cabinFrom.page = page;
      },
      async detailClick(id) {
        this.detailData = {};
        this.detailDialogVisible = true;
        const res = await shipDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          ...res.data,
          img: res.data.uploadShip ? res.data.uploadShip.split(',') : [],
        };
        this.operationData = res.data.operateRecordList;
      },
      resetClick(id) {
        this.$confirm('确定要删除当前船舶吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipDelete(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._shipPageList();
          })
          .catch(() => {
          });
      },
      disableClick(id) {
        this.$confirm('确定要禁用当前船舶吗', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._shipPageList();
          })
          .catch(() => {
          });
      },
      enableClick(id) {
        this.$confirm('确定要启用当前船舶吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipIsEnable(id);
            if (res.status !== 0) {
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            await this._shipPageList();
          })
          .catch(() => {
          });
      },
      changeClick(item) {
        this.dialogVisible = true;
        this.dialogTitle = '修改船舶';
        const imgArr = item.uploadShip ? item.uploadShip.split(',') : [];
        const img = [];
        imgArr.forEach(item => img.push({ url: baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (item) + '&access_token=' + this.token }));
        this.shipData = {
          ...item,
          type: {
            id: item.supplierId,
            name: item.supplierName,
          },
          keyword: item.keyWord,
          sTell: item.phone,
          numb: item.callNumber,
          IMO: item.imoNumber,
          MMSI: item.mmsi,
          size: item.grossTon,
          deadWeight: item.loadTon,
          speed: item.economySpeed,
          long: item.longSize,
          width: item.widthSize,
          height: item.heightSize,
          captain: item.shipName,
          tell: item.shipPhone,
          img,
        };
      },
      dialogClose() {
        this.dialogVisible = false;
        this.shipData.img = [];
        this.$refs.ruleForm.resetFields();
      },
      addClick() {
        this.shipData = removeSpace(this.shipData);
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let str = '';
            console.log(this.shipData.img);
            this.shipData.img.forEach(item => {
              if (!item.response) {
                str += item.url.match(/attachmentId=(.*)&/)[1] + ',';
              } else {
                str += item.response.data.id + ',';
              }
            });
            console.log(str);
            str = str.slice(0, str.length - 1);
            this.formLoading = true;
            const obj = {
              id: this.shipData.id,
              uploadShip: str,
              supplierId: this.shipData.type.id,
              supplierName: this.shipData.type.name,
              account: this.shipData.account,
              password: this.shipData.password,
              keyWord: this.shipData.keyword,
              name: this.shipData.name,
              phone: this.shipData.sTell,
              callNumber: this.shipData.numb,
              imoNumber: this.shipData.IMO,
              mmsi: this.shipData.MMSI,
              grossTon: this.shipData.size,
              loadTon: this.shipData.deadWeight,
              maxSpeed: this.shipData.maxSpeed,
              economySpeed: this.shipData.speed,
              longSize: this.shipData.long,
              widthSize: this.shipData.width,
              heightSize: this.shipData.height,
              draft: this.shipData.draft,
              // shipName:this.shipData.captain,
              // shipPhone:this.shipData.tell,
            };
            const res = this.dialogTitle === '添加船舶' ? await shipAdd(obj) : await shipUpdate(obj);
            if (res.status !== 0) {
              this.formLoading = false;
              return this.$message.error(res.message);
            } else {
              this.$message.success(res.message);
            }
            this.shipData.img = [];
            await this._shipPageList();
            this.dialogVisible = false;
            this.formLoading = false;
          } else {
            return false;
          }
        });
      },
      beforeAvatarUpload(file) {
        const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg'];
        const isJPG = TypeArr.includes(file.type);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式');
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');
        this.imgIsUpload = true;
        return isJPG && isLt10M;
      },
      uploadChange(file, fileList) {
        this.shipData.img = fileList;
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status !== 0) {
            this.shipData.img.splice(this.shipData.img.indexOf(file), 1);
          }
        }
      },
      handleRemove(file, fileList) {
        this.shipData.img = fileList;
      },
      progress() {
        this.imgIsUpload = true;
      },
      success(res) {
        this.imgIsUpload = false;
        if (res.status !== 0) this.$message.error('该图片上传失败！');
        this.$message.success('该图片上传成功！');
        this.imgIsUpload = false;
      },
      async _shipCabinPageList() {
        let res = await shipCabinPageList(this.cabinFrom);
        if (res.status !== 0) return this.$message.error(res.message);
        this.cabinTable = res.data.records;
        this.cabinTotal = res.data.total;
      },
      cabinClick(row) {
        let {
          name,
          callNumber,
        } = row;
        this.cabinVisible = true;
        this.cabinFrom.name = name;
        this.cabinFrom.shipId = row.id;
        this.cabinFrom.callNumber = callNumber;
        this.cabinData.shipId = row.id;

        this.tempShipId = row.id;

        this.cabinFrom.cabinName = '';
        this.cabinFrom.status = '';

        this._shipCabinPageList();

      },
      tableIndexMethod(index) {
        return this.cabinFrom.rows * (this.cabinFrom.page - 1) + index + 1;
      },
      cabinResetClick(id) {
        this.$confirm('确定要删除当前船舱吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipCabinDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._shipCabinPageList();
          })
          .catch(() => {
          });


      },
      async cabinEnableClick(id) {
        let res = await shipCabinIsEnable(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._shipCabinPageList();
      },
      cabinChangeClick(row) {
        this.cabinAddVisible = true;
        this.cabinDialogName = '修改';
        let {
          id,
          shipId,
          freeNumber,
          cabinName,
          capacity,
        } = row;
        this.cabinData = {
          id: id,
          shipId: shipId,
          cabinName: cabinName,
          boatNumber: capacity,
          freeNumber: freeNumber,
        };
      },
      cabinAddClick() {
        this.$refs.cabinRuleForm.validate(async (valid) => {
          if (valid) {
            if (this.cabinDialogName !== '修改') {
              let {
                shipId,
                cabinName,
                boatNumber,
                freeNumber,
              } = this.cabinData;
              let res = await shipCabinAdd({
                shipId: this.tempShipId,
                cabinName: cabinName,
                capacity: boatNumber,
                freeNumber: freeNumber,
              });
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            } else {
              let {
                id,
                shipId,
                cabinName,
                boatNumber,
                freeNumber,
              } = this.cabinData;
              let res = await shipCabinUpdate({
                id: id,
                shipId: shipId,
                cabinName: cabinName,
                capacity: boatNumber,
                freeNumber: freeNumber,
              });
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
            }

            this.cabinAddVisible = false;
            this.cabinDialogClose();
            await this._shipCabinPageList();

          } else {

          }
        });
      },
      cabinDialogClose() {
        this.$refs.cabinRuleForm.resetFields();
        this.cabinData = {
          shipId: '',
          cabinName: '',
          boatNumber: '',
          freeNumber: '',
        };
        this.cabinAddVisible = false;
      },
      cabinAdd() {
        this.cabinAddVisible = true;
        this.cabinDialogName = '添加';
      },

      // 船舱管理弹窗 —— 查询
      searchShip() {
        this.cabinFrom.cabinName = this.shipTerm.cabinName;
        this.cabinFrom.status = this.shipTerm.status;
        this._shipCabinPageList();
      },
      // 船舱管理弹窗 —— 重置
      resetShip() {
        this.shipTerm = {
          cabinName: '',
          status: '',
        };
      },

      // 船舱管理弹窗 —— 获取船舱管理状态
      getStatus(row) {
        switch (row.status) {
          case 0:
            return '禁用中';
          case 1:
            return '启用中';
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .img-box {
      position: relative;
      width: 150px;
      height: 100px;

      img {
        width: 150px;
        height: 100px;
      }

      .tips {
        position: absolute;
        display: none;
      }

      &:hover .tips {
        display: block;
        position: absolute;
        bottom: 0;
        top: 0;
        left: 0;
        color: #FFF;
        width: 146px;
        z-index: 10;
        height: 148px;
        background: #000;
        opacity: 0.6;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px;
      height: 75vh;
      overflow: auto;

      .upload-demo {
        display: inline-block;
        width: 170px;

        .img-box {
          width: 130px;
          height: 80px;

          img {
            width: 130px;
            height: 80px;
          }

          &:hover .tips {
            width: 130px;
            height: 80px;
          }
        }
      }

      .imgUp {
        display: flex;
        flex-direction: column;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        //.el-input__inner{
        //  border: none;
        //}
        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .permissions {
      width: 100%;
      padding: 20px 10px 20px 50px;

      .name {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          color: #2F1010;
        }
      }

      .content1 {
        p {
          color: #2F1010;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 10px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .cabin {
      padding: 25px;
      width: 100%;
    }

  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-table td {
      padding: 5px 0px !important;
    }
  }
</style>
